import {useInjection} from "inversify-react";
import {useCallback, useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {DiscountCodeApi, DiscountCodeDto} from "../../api";
import DiscountCodesList from "./discountCodeList";
import styles from "./discountCodeListContainer.module.less";
import {useNavigate} from "react-router-dom";
import {RoutingPaths} from "../routing/routingContainer";

export default function DiscountCodesListContainer() {
    const apiService = useInjection(ApiService);
    const [discountCodes, setDiscountCodes] = useState<DiscountCodeDto[] | null>();
    const navigate = useNavigate();

    const refreshDiscountCodesList = useCallback(async () => {
        try {
            const discountCodes = await apiService.getApi(DiscountCodeApi).apiDiscountCodeGet();
            setDiscountCodes(discountCodes.data);
        } catch (e: any) {
            console.log(e.response.data);
        }
    }, [apiService]);

    const onAddClicked = () => {
        navigate(RoutingPaths.discountCodeAdd.route);
    }

    const onEditClicked = (id: number) => {
        navigate(RoutingPaths.discountCodeEdit.route.replace(":id", id.toString()));
    }

    const onDeleteClicked = async (id: number) => {
        const response = await apiService.getApi(DiscountCodeApi).apiDiscountCodeIdDelete(id)

        if (response.request.status !== 200) {
            console.log("Error occured while deleting data"); //add any warnings?
        } else {
            refreshDiscountCodesList();
        }
    }

    useEffect(() => {
        refreshDiscountCodesList();
    }, [refreshDiscountCodesList]);

    return <div className={styles.content}>
        <DiscountCodesList data={discountCodes || null}
                           onAddClicked={onAddClicked}
                           onEditClicked={onEditClicked}
                           onDeleteClicked={onDeleteClicked}
        />
    </div>
}
